import React, { useState, useEffect } from "react";
import FormItem from "../../../components/FormItem";
import t from "../../../helpers/t";
import { moment } from "../../../../../vendor";
import { contingentsActions, pricesActions, useSelector } from "inbooma-api";
import { Biscuit } from "../../../../utils";
import Loader from "../../../components/Loader";
import Dialog from "@material-ui/core/Dialog";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-GB";
// @ts-ignore
import DatePicker from "react-datepicker";
// @ts-ignore
import { CenterDiv } from "../styled_components/divs";

type PriceTestProps = {
  dispatch: any;
  pricetariff: any;
  handleCloseDialog: any;
};

type PriceRequest = {
  begin?: string | null;
  end?: string | null;
  contingent_id?: number | null;
  pricetariff_id?: number;
  count_of_contingents?: number;
};

type SelectItem = {
  name: string;
  value: number | string | null;
};
const PriceTest = (props: PriceTestProps) => {
  const { dispatch, pricetariff, handleCloseDialog } = props;
  const _contingents = useSelector((state: any) => state.contingents_data.contingents);
  const _prices = useSelector((state: any) => state.prices_data.calculatePrice);
  const [mprice, setMprice] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [priceLoading, setPriceLoading] = useState<boolean>(false);
  const [initialized, setInitialized] = useState<boolean>(false);
  const [selectedContingent, setSelectedContingent] = useState<number | null>(null);
  const [selectedFromDate, setSelectedFromDate] = useState<string | number | Date>(
    moment().format("YYYY-MM-DD"),
  );
  const [selectedFromTime, setSelectedFromTime] = useState<
    string | readonly string[] | number | undefined
  >(moment().format("HH:mm"));
  const [selectedToDate, setSelectedToDate] = useState<string | number | Date>(
    moment().format("YYYY-MM-DD"),
  );
  const [selectedToTime, setSelectedToTime] = useState<
    string | readonly string[] | number | undefined
  >(moment().format("HH:mm"));
  const initialeState: PriceRequest = {
    begin: moment(selectedFromDate).format("YYYY-MM-DD") + " " + selectedFromTime + ":00",
    end: moment(selectedToDate).format("YYYY-MM-DD") + " " + selectedToTime + ":00",
    contingent_id: null,
    pricetariff_id: pricetariff.id,
    count_of_contingents: 1,
  };
  const [getPriceRequest, setGetPriceRequest] = useState<PriceRequest>(initialeState);

  useEffect(() => {
    if (loading || initialized) {
      return;
    }
    pricetariff.products.forEach((product: any) => {
      dispatch(
        contingentsActions.getContingents({
          token: Biscuit.get("token"),
          filter: {
            product_id: product.id,
          },
        }),
      );
    });
    setInitialized(true);
    setLoading(true);
  }, []);

  useEffect(() => {
    if (_contingents.success === "" || !loading) {
      return;
    }
    if (_contingents.success === true) {
      if (_contingents.data.length < 2 && _contingents.data.length > 0) {
        setSelectedContingent(_contingents.data[0].id);
        const temp: PriceRequest = {};
        Object.assign(temp, getPriceRequest);
        temp.contingent_id = _contingents.data[0].id;
        setGetPriceRequest(temp);
      }
    }
    setLoading(false);
  }, [_contingents]);

  useEffect(() => {
    if (_prices.success === "" || !priceLoading) {
      return;
    }
    if (_prices.success === true) {
      setMprice(_prices.data.price);
    }
    setPriceLoading(false);
  }, [_prices]);

  useEffect(() => {
    const temp: PriceRequest = {};
    Object.assign(temp, getPriceRequest);
    let date: any = moment().format("YYYY-MM-DD"),
      time: any = moment().format("HH:mm:00");
    if (selectedFromDate !== null) {
      date = moment(selectedFromDate).format("YYYY-MM-DD");
      time = selectedFromTime + ":00";
      temp.begin = date + " " + time;
    }
    setGetPriceRequest(temp);
  }, [selectedFromTime]);

  useEffect(() => {
    const temp: PriceRequest = {};
    Object.assign(temp, getPriceRequest);
    let date: any = moment().format("YYYY-MM-DD"),
      time: any = moment().format("HH:mm:00");
    if (selectedToDate !== null) {
      date = moment(selectedToDate).format("YYYY-MM-DD");
      time = selectedToTime + ":00";
      temp.end = date + " " + time;
    }
    setGetPriceRequest(temp);
  }, [selectedToTime]);
  const calculate = () => {
    dispatch(pricesActions.calculatePrice(getPriceRequest));
    setPriceLoading(true);
  };

  const onChangeFieldFrom = (dates: any) => {
    const temp: PriceRequest = {};
    Object.assign(temp, getPriceRequest);
    let date: any, time: any;
    setSelectedFromDate(dates);

    if (selectedFromTime !== null && typeof selectedFromTime !== "undefined") {
      date = moment(dates).format("YYYY-MM-DD");
      time = selectedFromTime + ":00";
      temp.begin = date + " " + time;
    }
    setGetPriceRequest(temp);
  };
  const onChangeFieldTo = (dates: any) => {
    const temp: PriceRequest = {};
    Object.assign(temp, getPriceRequest);
    let date: any, time: any;
    setSelectedToDate(dates);
    if (selectedToTime !== null && typeof selectedToTime !== "undefined") {
      date = moment(dates).format("YYYY-MM-DD");
      time = selectedToTime + ":00";
      temp.end = date + " " + time;
    }
    setGetPriceRequest(temp);
  };

  const onChangeContingent = (e: any) => {
    const temp: PriceRequest = {};
    Object.assign(temp, getPriceRequest);
    temp.contingent_id = Number(e.currentTarget.value);
    setSelectedContingent(e.currentTarget.value);
    setGetPriceRequest(temp);
  };
  const onChangeField = (e: any) => {
    const temp: PriceRequest = {};
    Object.assign(temp, getPriceRequest);
    switch (e.currentTarget.name) {
      case "amount":
        temp.count_of_contingents = Number(e.currentTarget.value);
        break;
    }
    setGetPriceRequest(temp);
  };

  return (
    <>
      {/* @ts-ignore */}
      <Dialog
        onClose={handleCloseDialog}
        aria-labelledby="pricetest-dialog-title"
        open={true}
        name="pricetestDialog"
        id="multipleRecipientsDialog"
        maxWidth={"md"}
      >
        <header className="inb-multiple-recipients-header">
          <button
            onClick={handleCloseDialog}
            type="button"
            id="inb-multiple-recipients-dialog-close-button"
            className="button hollow secondary right button-close-multiple-recipients-dialog round"
            title={t("close price test")}
          >
            <i className="fi fi-x"></i>
          </button>
          <h4>
            {t("price test for", null, "capital")} {pricetariff.name}
          </h4>
        </header>
        <div
          id="inb-c-main-multiple-recipients"
          className="inb-c-listing off-canvas-content"
          data-off-canvas-content=""
        >
          {_contingents?.data?.length > 0 ? (
            <>
              <div className="inb-c-item inb-c-item--recipient row" key={_contingents.data.length}>
                <FormItem
                  name="contingent_id"
                  inputType="select"
                  id={"contingent_id_new"}
                  label={t("contingent", null, "capital")}
                  type="select"
                  dataKey="id"
                  data={_contingents.data}
                  selected={selectedContingent}
                  mediumWidth={6}
                  smallWidth={12}
                  onChangeHandler={onChangeContingent}
                  placeholder={t("please_select")}
                  extraTopClasses="resourcetype_select"
                />

                <FormItem
                  name="amount"
                  inputType="number"
                  id={"amount"}
                  label={t("count_units", null, "capital")}
                  type="input"
                  value={getPriceRequest.count_of_contingents}
                  mediumWidth={2}
                  smallWidth={6}
                  noIdForName={true}
                  onChangeHandler={onChangeField}
                  labelStyle={{ width: "100%" }}
                  inputStyle={{ width: "100%" }}
                  notTiny={true}
                />
              </div>
              <div
                className="inb-c-item inb-c-item--recipient row"
                key={_contingents.data.length + 1}
              >
                <div className="small-6 column">
                  <div className="input-group inb-price-input-group">
                    <div className="float-left">
                      <DatePicker
                        key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                        className="input-group-field"
                        dateFormat="dd. MMMM y"
                        selected={new Date(selectedFromDate)}
                        onChange={(date: any) => onChangeFieldFrom(date)}
                        onKeyDown={(e: any) => {
                          if (e.keyCode === 8) e.preventDefault();
                        }}
                        placeholderText=""
                        locale={
                          Biscuit.get("user.lang").indexOf("de") >= 0
                            ? de
                            : Biscuit.get("user.lang").indexOf("fr") >= 0
                              ? fr
                              : en
                        }
                      />
                    </div>
                    <input
                      className="input-group-field"
                      type="time"
                      name="valid_from_time_field"
                      value={selectedFromTime}
                      style={{ maxWidth: "40%" }}
                      onChange={(e) => {
                        setSelectedFromTime(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="small-6 column">
                  <div className="input-group inb-price-input-group">
                    <div className="float-left">
                      <DatePicker
                        key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                        label={t("to")}
                        className="input-group-field"
                        dateFormat="dd. MMMM y"
                        selected={new Date(selectedToDate)}
                        onChange={(date: any) => onChangeFieldTo(date)}
                        onKeyDown={(e: any) => {
                          if (e.keyCode === 8) e.preventDefault();
                        }}
                        placeholderText=""
                        locale={
                          Biscuit.get("user.lang").indexOf("de") >= 0
                            ? de
                            : Biscuit.get("user.lang").indexOf("fr") >= 0
                              ? fr
                              : en
                        }
                      />
                    </div>
                    <input
                      className="input-group-field"
                      type="time"
                      name="valid_from_time_field"
                      value={selectedToTime}
                      style={{ maxWidth: "40%" }}
                      onChange={(e) => {
                        setSelectedToTime(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              {mprice !== null && !priceLoading ? (
                <>
                  <div
                    className="inb-c-item inb-c-item--recipient row"
                    key={_contingents.data.length + 3}
                  >
                    <span className="inb-price-label column medium-1">{t("price")}: </span>
                    <span className="inb-price-value column medium-3">
                      {mprice.price.toString()}€
                    </span>
                    <span className="inb-price-label column medium-2">{t("priceinfo")}: </span>
                    <span className="inb-price-value column medium-6">
                      {mprice.info.toString()}
                    </span>
                  </div>
                </>
              ) : (
                mprice !== null &&
                priceLoading && (
                  <>
                    <span className="inb-price-label column medium-1">{t("price")}: </span>
                    <span className="inb-price-value column medium-3">
                      <Loader mediumWidth={3} smallWidth={3} subLoaders={0} />
                    </span>
                    <span className="inb-price-label column medium-2">{t("priceinfo")}: </span>
                    <span className="inb-price-value column medium-6">
                      <Loader mediumWidth={3} smallWidth={3} subLoaders={0} />
                    </span>
                  </>
                )
              )}
              <div
                className="inb-c-item inb-c-item--recipient row"
                key={_contingents.data.length + 2}
              >
                <CenterDiv className="row medium-12 small-12" style={{ paddingTop: "20px" }}>
                  <a
                    href="#"
                    id="inb-c-left-bar-add-resource"
                    onClick={calculate}
                    className={"button beautify beautify-" + Biscuit.get("user.client_id")}
                  >
                    <i className="fi fi-check"></i>
                    <span> {t("calculate price")}</span>
                  </a>
                </CenterDiv>
              </div>
            </>
          ) : loading ? (
            <>
              {" "}
              <Loader mediumWidth={6} smallWidth={6} subLoaders={0} />
            </>
          ) : (
            <>
              <div id="inb-app-collection-empty" className="inb-announcement">
                <div className="inb-image-box">
                  <img src="assets/img/no_data.svg" />
                </div>
                <h3>{t("app_msg_collection_empty")}</h3>
                <p>{t("app_msg_collection_empty_body")}</p>
              </div>
            </>
          )}
        </div>
      </Dialog>
    </>
  );
};
export default PriceTest;
